module.exports = __webpack_public_path__ + "img/Bild1.8d1afea9.jpg";